<template>
  <div class="scheduled-report-empty">
    <div class="empty-card">
      <div class="empty-left">
        <h5 class="empty-title">No Scheduled Reports Created Yet</h5>
        <p class="empty-desc mt-2">
          Set it once, and let Scheduled Reports deliver your data automatically. Decide what to send, when to send it, and who receives it. No manual work required.
        </p>
        <ul class="empty-features">
          <li>
            <span class="feature-icon">
              <v-icon small color="#1B6EF3">mdi-file-document-outline</v-icon>
            </span>
            Pick any report template
          </li>
          <li>
            <span class="feature-icon">
              <v-icon small color="#1B6EF3">mdi-calendar-clock</v-icon>
            </span>
            Set frequency and delivery date/time
          </li>
          <li>
            <span class="feature-icon">
              <v-icon small color="#1B6EF3">mdi-email-outline</v-icon>
            </span>
            Send automatically to one or multiple recipients
          </li>
          <li>
            <span class="feature-icon">
              <v-icon small color="#1B6EF3">mdi-clock-outline</v-icon>
            </span>
            Run on schedule always on time
          </li>
        </ul>
        <a href="/dashboard/scheduled_report/new">
          <button class="btn btn-primary d-flex align-items-center">
            <v-icon small color="#ffffff" class="mr-1">mdi-plus</v-icon>
            New Scheduled Report
          </button>
        </a>
      </div>
      <div class="empty-right mt-3">
        <div class="how-card">
          <div class="how-title">How it works</div>

          <div class="how-step">
            <div class="step-icon step-icon--blue">
              <v-icon small color="#1B6EF3">mdi-file-document-outline</v-icon>
            </div>
            <div class="step-body">
              <div class="step-label">Choose a template</div>
              <div class="step-value">Monthly Case Overview</div>
            </div>
          </div>

          <div class="how-arrow">
            <v-icon small color="#BDBDBD">mdi-arrow-down</v-icon>
          </div>

          <div class="how-step">
            <div class="step-icon step-icon--orange">
              <v-icon small color="#F2994A">mdi-clock-outline</v-icon>
            </div>
            <div class="step-body">
              <div class="step-label">Set frequency</div>
              <div class="step-value">Every month • 9:00 AM</div>
            </div>
          </div>

          <div class="how-arrow">
            <v-icon small color="#BDBDBD">mdi-arrow-down</v-icon>
          </div>

          <div class="how-step">
            <div class="step-icon step-icon--purple">
              <v-icon small color="#7B61FF">mdi-email-outline</v-icon>
            </div>
            <div class="step-body">
              <div class="step-label">Send to recipients</div>
              <div class="step-value">johndoe@mail.com <span class="more-pill">+2 more</span></div>
            </div>
          </div>

          <div class="how-divider"></div>

          <div class="how-file">
            <div class="file-icon">
              <v-icon small color="#4F4F4F">mdi-file-document-outline</v-icon>
            </div>
            <div class="file-body">
              <div class="file-name">
                <span>monthly</span>-case-overview-jan-2026
              </div>
              <div class="file-meta">Delivered automatically on schedule</div>
            </div>
            <span class="file-badge">CSV</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.scheduled-report-empty {
  margin-top: 24px;
  font-family: 'Lato';
  color: #3F3F3F;
}

.empty-card {
  background: #FCFDFF;
  border: 1px solid #D7D7D7;
  border-radius: 16px;
  padding: 113px 150px ;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.empty-left {
  flex: 1;
  min-width: 320px;
  max-width: 511px;
  margin-top: 20px;
}

.empty-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 8px;
}

.empty-subtitle {
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 16px;

}

.empty-desc {
  color: #4F4F4F;
  margin-bottom: 16px;
}

.empty-features {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  display: grid;
  gap: 12px;
}

.empty-features li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #4F4F4F;
}

.feature-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #E8F1FF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
}

.empty-right {
  width: 421px;
  flex: 0 0 421px;
}

.how-card {
  border: 1px solid #E0E0E0;
  border-radius: 14px;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.how-title {
  font-weight: 700;
  margin-bottom: 12px;
}

.how-step {
  display: flex;
  gap: 12px;
  align-items: center;
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  padding: 10px 12px;
}

.step-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F2F4F7;
  flex: 0 0 30px;
}

.step-icon--blue {
  background: #E8F1FF;
}

.step-icon--orange {
  background: #FFF4E5;
}

.step-icon--purple {
  background: #EEE9FF;
}

.step-body {
  flex: 1;
}

.step-label {
  font-size: 12px;
  color: #7A7A7A;
}

.step-value {
  font-weight: 600;
}

.pill {
  background: #FFF2C6;
  padding: 2px 6px;
  border-radius: 6px;
  font-weight: 700;
}

.more-pill {
  color: #2F80ED;
  font-weight: 600;
  margin-left: 6px;
}

.how-arrow {
  text-align: center;
  margin: 6px 0;
}

.how-divider {
  border-top: 1px dashed #E0E0E0;
  margin: 12px 0;
}

.how-file {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #E9E9E9;
  border-radius: 10px;
  padding: 12px;
}

.file-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #F2F2F2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-body {
  flex: 1;
}

.file-name {
  font-weight: 600;
}

.file-meta {
  font-size: 12px;
  color: #7A7A7A;
}

.file-badge {
  border: 1px solid #D0D0D0;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #4F4F4F;
}

.highlight {
  background: #FFF2C6;
  padding: 0 4px;
  border-radius: 4px;
}

@media (max-width: 1200px) {
  .empty-card {
    flex-direction: column;
  }

  .empty-right {
    width: 100%;
    flex: 1;
  }
}
</style>
